import { useState, useEffect, useRef } from 'react';
import useToken from 'hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';

/**
 * Hook para manejar la obtenci�n y gesti�n de detalles del lead
 * @param {number} idLead - ID del lead a obtener
 * @param {boolean} showModal - Estado del modal
 * @param {Function} setContactos - Funci�n para actualizar contactos
 * @param {Array} contactos - Lista de contactos
 * @returns {Object} Objeto con estados y funciones del lead
 */
export const useLeadDetails = (idLead, showModal) => {
    const { token, setToken, idUsuario } = useToken();
    const { showErrorToast } = useToast();

    const [cargandoModal, setCargandoModal] = useState(false);
    const [procesandoModal, setProcesandoModal] = useState(false);
    const [detallesLead, setDetallesLead] = useState({ idSource: 0, idLead: 0 });
    const [eventosActivos, setEventosActivos] = useState([]);
    const [listaJsonLeadsVinculados, setListaJsonLeadsVinculados] = useState([]);
    const [tags, setTags] = useState([]);
    const [catEtapas, setCatEtapas] = useState([]);
    const [vendedor, setVendedor] = useState(0);
    
    // Ref para rastrear el �ltimo lead cargado
    const lastLoadedLead = useRef(null);
    const loadingRef = useRef(false);

    useEffect(() => {
        const shouldLoadLead = showModal && idLead > 0 && token && lastLoadedLead.current !== idLead;
        
        if (shouldLoadLead) {
            console.log(`[useLeadDetails] Cargando datos para lead ${idLead}`);
            ObtenerDatosLead(idLead);
        } else if (!showModal) {
            // Resetear cuando se cierra el modal
            console.log('[useLeadDetails] Modal cerrado, reseteando datos');
            setDetallesLead({ idSource: 0, idLead: 0 });
            setEventosActivos([]);
            setListaJsonLeadsVinculados([]);
            lastLoadedLead.current = null;
        }
    }, [showModal, idLead, token]);

    const ObtenerDatosLead = async (idLead) => {
        if (idLead <= 0) return;

        // Evitar llamadas duplicadas
        if (loadingRef.current) {
            console.log('[useLeadDetails] Ya hay una carga en progreso, ignorando...');
            return;
        }

        if (!token) {
            console.log('[useLeadDetails] No hay token disponible');
            return;
        }

        loadingRef.current = true;

        var idVendedor_ = sessionStorage.getItem("selectIDUsuario") == null 
            ? (vendedor == 0) ? idUsuario : vendedor 
            : sessionStorage.getItem("selectIDUsuario");
        setVendedor(idVendedor_);

        setCargandoModal(true);
        setProcesandoModal(true);

        try {
            const response = await fetch("/api/leads/ObtenerDetallesLead/?idLead=" + idLead, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                console.log("==== OBTENER DATOS LEAD ====");
                const data = await response.json();

                if (data.iResponseType == 1) {
                    var ObjDetalles = JSON.parse(data.detalles);

                    setDetallesLead(ObjDetalles["table2"][0]);
                    setEventosActivos(ObjDetalles["table3"]);
                    setTags(ObjDetalles["table4"]);
                    setCatEtapas(ObjDetalles["table5"]);

                    var leadsVinculados = JSON.parse(ObjDetalles["table2"][0].vJsonLeadsVinculados);
                    const newArray = leadsVinculados.filter(e => e.idLead !== ObjDetalles["table2"][0].idLead);
                    setListaJsonLeadsVinculados(newArray);
                    
                    lastLoadedLead.current = idLead;
                    console.log(`[useLeadDetails] Datos del lead ${idLead} cargados exitosamente`);
                } else {
                    showErrorToast(data.vMessage);
                }
            } else {
                showErrorToast(response.status + ' ' + response.statusText);
                if (response.status == 401) {
                    setToken(null);
                    location.href = "";
                }
            }
        } catch (error) {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.error('Error al obtener detalles del lead:', error);
        } finally {
            setCargandoModal(false);
            setProcesandoModal(false);
            loadingRef.current = false;
        }
    };

    return {
        cargandoModal,
        procesandoModal,
        detallesLead,
        setDetallesLead,
        eventosActivos,
        setEventosActivos,
        listaJsonLeadsVinculados,
        setListaJsonLeadsVinculados,
        tags,
        catEtapas,
        vendedor,
        ObtenerDatosLead
    };
};
